export default "__VITE_ASSET__20b6d6b8__$_?nuxt_component=async__"